import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "../site/Motion";
import { useRfq } from "../site/RfqContext";
import { useSettings, waLink } from "../../lib/api";

export const CtaBand = () => {
  const { open } = useRfq();
  const s = useSettings();
  return (
    <section data-testid="cta-band" className="relative overflow-hidden bg-[#0a6cff] py-20 text-white md:py-28">
      <img src="/logo-mark.png" alt="" aria-hidden className="pointer-events-none absolute -right-20 -top-20 h-[520px] w-[520px] object-contain opacity-[0.14] mix-blend-luminosity" />
      <div className="container-x relative flex flex-col justify-between gap-10 lg:flex-row lg:items-end">
        <Reveal>
          <p className="eyebrow text-white/80">Have a drawing or sample?</p>
          <h2 className="font-display mt-4 max-w-4xl text-5xl font-black uppercase leading-[0.88] sm:text-6xl lg:text-8xl">Send it. We'll quote it.</h2>
        </Reveal>
        <Reveal delay={0.15} className="flex flex-wrap gap-4">
          <button data-testid="cta-rfq-button" onClick={() => open()} className="inline-flex items-center gap-2 bg-[#07090e] px-7 py-4 text-sm font-semibold uppercase tracking-wider text-white transition-transform duration-300 hover:-translate-y-1">
            Request a Quote <ArrowRight className="h-4 w-4" />
          </button>
          <a data-testid="cta-whatsapp-button" href={waLink(s.whatsapp)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-white/60 px-7 py-4 text-sm font-semibold uppercase tracking-wider transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-white/10">
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
          <Link to="/contact" data-testid="cta-contact-link" className="self-center text-sm font-semibold underline-offset-4 hover:underline">Contact page →</Link>
        </Reveal>
      </div>
    </section>
  );
};
